var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnLocation24 = function SvgLightIcnLocation24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.694c0 2.99-1.762 5.52-3.602 7.338a20 20 0 0 1-3.34 2.65l-.058.035-.057-.035a20.122 20.122 0 0 1-3.341-2.65C6.762 16.213 5 13.683 5 10.694 5 6.894 8.127 3.8 12 3.8s7 3.093 7 6.894"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10.8,
    r: 3
  })));
};
export default SvgLightIcnLocation24;